/**
 * Crawlers and automation that execute JavaScript: Google's AdsBot/Storebot/Googlebot render
 * VDPs, plus Bing, Meta's link crawler, SEO tools and headless browsers. They must not get a
 * visitor session or a landing context. Every page fetch starts with an empty cookie jar, so each
 * fetch used to become a new one-event DIRECT session: on prod 23–27.09.2026, 54% of DIRECT
 * sessions came from published Google/Bing/Meta crawler IP ranges.
 *
 * The list uses explicit tokens instead of a bare /bot/ because device names such as "CUBOT"
 * appear in real Android user agents. A URL inside the user agent is the generic crawler
 * signature, since real browsers never send one.
 * Same list as fe-landing's ImpressionBeacon.ts. Keep the two in sync.
 */
const AUTOMATED_AGENT_UA = new RegExp([
    'https?://', 'googlebot', 'adsbot', 'storebot', 'google-inspectiontool', 'googleother', 'google-read-aloud',
    'google-extended', 'mediapartners-google', 'apis-google', 'feedfetcher', 'google-safety', 'bingbot', 'bingpreview',
    'adidxbot', 'msnbot', 'duckduckbot', 'applebot', 'yandexbot', 'baiduspider', 'petalbot', 'bytespider', 'semrushbot',
    'ahrefsbot', 'mj12bot', 'dotbot', 'seznambot', 'facebookexternalhit', 'facebookcatalog', 'meta-externalagent',
    'twitterbot', 'linkedinbot', 'slackbot', 'telegrambot', 'whatsapp', 'discordbot', 'pinterestbot', 'gptbot',
    'oai-searchbot', 'chatgpt-user', 'claudebot', 'claude-user', 'perplexitybot', 'amazonbot', 'ccbot', 'headlesschrome',
    'lighthouse', 'pagespeed', 'gtmetrix', 'pingdom', 'uptimerobot', 'statuscake', 'site24x7', 'crawler', 'spider', 'slurp',
].join('|'), 'i');
export const isAutomatedAgent = () => {
    if (typeof navigator === 'undefined')
        return false;
    return Boolean(navigator.webdriver) || AUTOMATED_AGENT_UA.test(navigator.userAgent || '');
};
